
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cleartax.in",
      function () {
        return require("private-next-pages/cleartax.in/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cleartax.in"])
      });
    }
  